import styles from './noListings.module.css';
import global from '../result.module.css';
import AreaContainer from "../AreaContainer";
import miscEvent from 'lib/ga/miscEvent';
import { modalSet, nextModalSet } from "_slices/view";
import { useDispatch } from "react-redux";
import { useRouter } from 'next/navigation'

type Props = {
    agents: agents[],
    setShowAllAgentContacts: any,
    isLoggedIn: boolean,
    id: number,
    type: string
}

type agents = {
    users: users[]
}

type users = {
    contacts
}

const NoListings = ({ agents, setShowAllAgentContacts, isLoggedIn, id, type }: Props) => {

    if (agents.length === 0) {
        return null;
    }
    const router = useRouter();
    const hasContacts = agents.filter(value => value.users.length > 0);
    let hasContactWithNumbers = false;
    let dispatch = useDispatch();

    for (const item in hasContacts) {
        for (const user in hasContacts[item].users) {
            const hasNumber = hasContacts[item].users[user].contacts.filter(value => value.number)
            if (hasNumber.length > 0) {
                hasContactWithNumbers = true;
                break;
            }
        }
    }


    return (
        <AreaContainer area={'availability'} style={null} extraClass={null}>
            <div className={styles.outerContainer} >
                <div className={styles.NoListingsContainer}>
                    <p>The landlord is not currently listing any units in this scheme, but this doesn’t mean there’s nothing available.</p>
                    <p className={`${global.boldText} ${styles.marginTop}`}>Contact the agent or landlord if you’re interested in renting a unit in this scheme.</p>

                    <div>
                        {hasContacts.length > 0 &&
                            <button
                                id="property-contact"
                                onClick={(e) => {
                                    const log = {
                                        event: 'show_all_agent_contacts',
                                        result_id: id,
                                        subject_type: type
                                    }
                                    miscEvent(log)

                                    const element = document.getElementById("agent-contain");
                                    window.scrollTo({
                                        top: element.getBoundingClientRect().top > 200 ? element.getBoundingClientRect().top - 200 : element.getBoundingClientRect().top,
                                        left: 0,
                                        behavior: "smooth",
                                    });
                                    setShowAllAgentContacts(true)
                                }}
                            >
                                {hasContactWithNumbers ? ' Call Agents' : 'Show agents'}
                            </button>
                        }

                        <button
                            id="property-contact"
                            onClick={(e) => {
                                if (isLoggedIn) {
                                    dispatch(
                                        modalSet({
                                            visible: true,
                                            type: "contactProperty",
                                            view: id.toString(),
                                            router: router,
                                        })
                                    );
                                } else {
                                    dispatch(
                                        modalSet({
                                            visible: true,
                                            type: "auth",
                                            view: "login",
                                            router: router,
                                        })
                                    );
                                    dispatch(
                                        nextModalSet({
                                            visible: true,
                                            type: "contactProperty",
                                            view: id.toString(),
                                            router: router,
                                        })
                                    );
                                }
                            }}
                        >
                            Email Agents
                        </button>
                    </div>
                </div>
            </div>
        </AreaContainer >
    )
}

export default NoListings;